module.exports = __webpack_public_path__ + "img/intercomscene1.0a82f897.png";